import React, {Component} from "react";
import style from "./style.scss";
import SideBarMenu from "../SideBarMenu";
import {StrokeIcon, FlatIcon} from "../Icon";
// redux
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
// UI Logic
import AuthLogic from '../../../AuthLogic';

class AppLeftSideBar extends Component {
    state = {
        menuItems: [
            {
                title: 'Dashboard',
                isSection: true,
                menuItems: [
                    {
                        title: 'My Quick Schedule',
                        icon: <StrokeIcon icon={'smile'}/>,
                        link: '/my-quick-schedule',
                        visible: true
                    },
                    {
                        title: 'View Schedules',
                        icon: <StrokeIcon icon={'clock'}/>,
                        link: '/schedules',
                        visible: true
                    },
                    // {
                    //     title: 'View / Accept Tours Offered',
                    //     icon: <FlatIcon icon={'tool'}/>,
                    //     link: '/tours-offered'
                    // },
                    {
                        title: 'Days Off and Availability',
                        icon: <StrokeIcon icon={'date'}/>,
                        link: '/day-types',
                        visible: (AuthLogic.viewCalendar(this.props.user) || AuthLogic.addDayTypeRequest(this.props.user))
                    },
                    // {
                    //     title: 'About',
                    //     icon: <StrokeIcon icon={'info'}/>,
                    //     link: '/about'
                    // }
                    {
                        title: 'STORM Help Ticket',
                        icon: <StrokeIcon icon={'help1'}/>,
                        link: 'https://nbcu.service-now.com/nbcusp?id=sc_cat_item&sys_id=a8108f526f922500e904f00dba3ee458&sysparm_appID=7039838',
                        isNewTab: true,
                        visible: true
                    },
            
                ]
            }
        ]
    }

    componentDidMount() {
        // const newMenuItems = this.state.menuItems;
        // const adjustWorkTimes = {
        //     title: 'Adjust Work Times',
        //     icon: <StrokeIcon icon={'tools'}/>,
        //     link: '/adjust-work-times'
        // };
        // if (AuthLogic.adjustWorkTimes(this.props.user)) {
        //     newMenuItems[0].menuItems.splice(1, 0, adjustWorkTimes);
        //     this.setState({
        //         menuItems: newMenuItems
        //     })
        // }
    }

    render() {
        return (
            <div className={style.appLeftSideBar}>
                <SideBarMenu onClickToggleLeftSideBar={this.props.onClickToggleLeftSideBar} menuItems={this.state.menuItems}/>
            </div>
        )
    }
}

AppLeftSideBar.propTypes = {
    user: PropTypes.object.isRequired
  };

function mapStateToProps(state) {
  return {
    user: state.user
  }
}

export default connect(
 mapStateToProps
)(AppLeftSideBar);



// WEBPACK FOOTER //
// ./src/Components/Theme/AppLeftSideBar/index.js